import React from 'react';

const RECA = () => (
  <div>
    <div className="subheader">
      <h1 className="subheader-title">
        <i className="subheader-icon fal fa-users-class mr-2" />
        RECA
        <span className="fw-300 ml-2 mr-2">Resources</span>
        <small>
          Tools, Guides and Standards
        </small>
      </h1>
    </div>
  </div>
);

export default RECA;
